/** Plugin HtmlDescription — eski Qbitra linklerini Robbot ile değiştirir veya gizler. */
export function sanitizePluginHintHtml(html) {
  if (!html || typeof html !== "string") return "";

  let out = html
    .replace(/qbitra\.com/gi, "robbot.com.tr")
    .replace(/Qbitra/g, "Robbot")
    .replace(/qbitra/g, "robbot");

  // Sadece eski qbitra linki varsa ve başka içerik yoksa gösterme
  if (/for more information visit/i.test(out) && out.replace(/<[^>]+>/g, "").trim().length < 80) {
    return "";
  }

  return out;
}
